var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "list-group form-control-products-type-features-wrapper" },
    _vm._l(_setup.features, function (feature, index) {
      return _c(
        "div",
        { key: feature.name + "-" + index, staticClass: "list-group-item" },
        [
          _c("div", { staticClass: "mb-1 small text-muted" }, [
            _vm._v(_vm._s(feature.name)),
          ]),
          _vm._v(" "),
          _vm.currentData[_vm.field.name] &&
          _vm.currentData[_vm.field.name][index]
            ? _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentData[_vm.field.name][index].value,
                      expression: "currentData[field.name][index].value",
                    },
                  ],
                  staticClass: "form-select",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.currentData[_vm.field.name][index],
                        "value",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("Select…")]),
                  _vm._v(" "),
                  _vm._l(
                    _setup.parseOptions(feature.options),
                    function (option) {
                      return _c(
                        "option",
                        { key: option, domProps: { value: option } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(option) +
                              "\n            "
                          ),
                        ]
                      )
                    }
                  ),
                ],
                2
              )
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }